import React
  from "react";

import { connect }
  from "react-redux";

import { CustomTextInput }
  from '../../components/shared/forms';

import { MemberList, EmailForm }
  from '../../components/settings/invited';

import { fetchInvitedFriends, inviteFriend }
  from '../../helpers/invitedHelper';

import { SuccessAlert }
  from '../../components/settings/shared';

class InviteFriend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      errors: null,
      email: "",
      invitedFriends: [],
      successUpdated: false
    };
  }

  componentDidMount() {
    fetchInvitedFriends(this.fetchFriends.bind(this))
  }

  fetchFriends(data) {
    this.setState({loading: false, invitedFriends: data.data})
  }

  onSubmitRequest() {
    let { email } = this.state
    this.setState({loading: true})
    inviteFriend(email, this.successInviteFriend.bind(this))
  }

  successInviteFriend() {
    this.setState({email: "", successUpdated: true})
    fetchInvitedFriends(this.fetchFriends.bind(this))
    let _this = this
    setTimeout(function(){ _this.setState({successUpdated: false}) }, 3000);
  }

  render() {
    const { currentUser, translate } = this.props
    let { invitedFriends, loading,successUpdated } = this.state

    return (
      <div className="col-md-12 col-lg-12 col-xl-8">
        <div className="settings-content">
          <div className="settings-invite">
            <div className="accordion" id="invite-accordion">
              <div className="accordion-item">
                <div className="accordion-head">
                  <div className="accordion-head-wrap">
                    <h2>{translate("settings.invite.friend_title")}</h2>
                  </div>
                </div>
                <div className="accordion-body">
                  <div className="accordion-body-wrap">
                    <div className="row settings-invite-wrap">
                      <EmailForm
                        email={this.state.email}
                        changeEmail={(e) => this.setState({email: e.target.value})}
                        onSubmit={this.onSubmitRequest.bind(this)}
                        translate={translate}
                        typeTranslate={translate("settings.invite.type_friend")}
                      />
                      <div className="col-md-6 col-lg-6">
                        <div className="settings-invite-content">
                          <p>{translate("settings.invite.friend_description")}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <MemberList
                items={invitedFriends}
                loading={loading}
                translate={translate}
                notFoundMessage={translate("settings.invite.not_found_friends_invited")}
              />
            </div>
          </div>
        </div>
        { successUpdated &&
          <SuccessAlert
            message={translate("settings.invite.friend_added_successfully")}
          />
        }
      </div>
    )
  }
};

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {  })(InviteFriend);
